import styled from "@emotion/styled";

// wrapper
export const Wrapper = styled.div`
// display: grid;
// grid-template-columns: repeat(2, 1fr);
//   gap: 0.5rem;
`;
// Documents container
export const DocumentsContainer = styled.div`
  width: 60%;
  display: grid;
  justify-content: flex-start;
  align-items: center;
  grid-template-columns: repeat(5, 1fr);
  gap: 2.5rem;
`;

export const H1 = styled.h1`
  margin-bottom: 2rem;
`;

export const btnContainer = styled.div`

display:grid;
justify-self: flex-end;

`;

export const CreateBtn = styled.button`
display:grid;
justify-self: flex-end;
  margin-top: 2rem;
  padding: 0.8rem 38px;
  border: 0.5px solid #000;
  border-radius: 40px;
  background-color: transparent;
  color: #080808;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
  
`;

export const SpinnerContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;